module.exports = __webpack_public_path__ + "img/168.cc945f99.svg";